import React from 'react';
import { Container, Typography } from '@mui/material';

const CRM: React.FC = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Typography variant="h4">CRM</Typography>
      <Typography color="text.secondary" sx={{ mt: 2 }}>
        CRM component - Full conversion needed
      </Typography>
    </Container>
  );
};

export default CRM;
